import React, { lazy } from 'react';

export interface RouteConfig {
  path: string;
  element: React.LazyExoticComponent<React.ComponentType>;
}

export const publicRoutes: RouteConfig[] = [
  {
    path: '/about',
    element: lazy(() => import('../pages/About')),
  },
  {
    path: '/docs',
    element: lazy(() => import('../pages/Docs')),
  },
  {
    path: '/guides',
    element: lazy(() => import('../pages/Guides')),
  },
  {
    path: '/help',
    element: lazy(() => import('../pages/Help')),
  },
  {
    path: '/links',
    element: lazy(() => import('../pages/LinksPage')),
  },
];

export const publicOnlyRoutes: RouteConfig[] = [
  {
    path: '/login',
    element: lazy(() => import('../pages/Login')),
  },
  {
    path: '/register',
    element: lazy(() => import('../pages/Register')),
  },
  {
    path: '/signup',
    element: lazy(() => import('../pages/Register')),
  },
];

export const privateRoutes: RouteConfig[] = [
  {
    path: '/dashboard',
    element: lazy(() => import('../pages/Dashboard')),
  },
  {
    path: '/aac',
    element: lazy(() => import('../pages/AAC')),
  },
  {
    path: '/voz',
    element: lazy(() => import('../pages/Home')),
  },
  {
    path: '/gesture-recognition',
    element: lazy(() => import('../pages/GestureRecognition')),
  },
  {
    path: '/contact',
    element: lazy(() => import('../pages/Contact')),
  },
  {
    path: '/profile',
    element: lazy(() => import('../pages/Profile')),
  },
  {
    path: '/historico',
    element: lazy(() => import('../pages/CommunicationHistoryPage')),
  },
];

export const notFoundRoute: RouteConfig = {
  path: '*',
  element: lazy(() => import('../pages/NotFound')),
};
